import { createDefaultEvaluationRules } from "@/features/execute-calculation-set/overmind/calculation/createDefaultEvaluationRules"
import { createNextEvaluationRules } from "@/features/execute-calculation-set/overmind/calculation/createNextEvaluationRules";
import { AlertScale } from "@/features/execute-calculation-set/overmind/calculation/domain/AlertScale";
import { EvaluationRule, EvaluationRules } from "@/features/execute-calculation-set/overmind/calculation/evaluation/EvaluationRule";
import { GUID } from "../auth"

let _rulesVariant: () => "default" | "next" | "api" | null = () => "default";
let _evaluationRulesProviderApiUrl: string = "";
let _accessToken: () => string = () => "";
export const evaluationRules = {
    initialize(rulesVariant: () => ("default" | "next" | "api" | null), evaluationRulesProviderApiUrl: string, accessToken: () => string) {
        _rulesVariant = rulesVariant;
        _evaluationRulesProviderApiUrl = evaluationRulesProviderApiUrl;
        _accessToken = accessToken;
    },
    provide(tenantId: GUID): Promise<EvaluationRules> {
        const rulesVersion = _rulesVariant();
        if (rulesVersion === "api") {
            const rules = fetch(`${_evaluationRulesProviderApiUrl}/v1/${tenantId}/evaluation-rules`, {
                headers: {
                    "Authorization": `Bearer ${_accessToken()}`,
            }}
            ).then(response => {
                    if (!response.ok) {
                        return createNextEvaluationRules()
                    }
                    return response
                        .json()
                        .then(data => {
                            const availableRules: EvaluationRules = {
                                type: "AVAILABLE",
                                rules: toRules(data)
                                        
                            }
        
                            return availableRules
                        })
                })
                .catch(error => {
                    const unavailableRules: EvaluationRules = { type: "UNAVAILABLE" }

                    return unavailableRules
                })

            return rules
        }
        if (rulesVersion === "next") {
            return Promise.resolve(createNextEvaluationRules());
        }
        
        return Promise.resolve(createDefaultEvaluationRules())
    }
}

type SerializedEvaluationRule = {
    lowerWarningVector: {
        lowerError: { value: number | "Infinity" | "-Infinity" },
        lowerWarning: { value: number | "Infinity" | "-Infinity" }
    },
    higherWarningVector: {
        higherWarning: { value: number | "Infinity" | "-Infinity" },
        higherError: { value: number | "Infinity" | "-Infinity" }
    }
}

type SerializedEvaluationRules = {
    [calculationProperty: string]: SerializedEvaluationRule
}
function toRules(data: SerializedEvaluationRules): EvaluationRule[] {
    return Object.entries(data).map(([calculationProperty, values]) => {
        return {
            calculationProperty,
            value: AlertScale.from(
                toScaleNumber(values.lowerWarningVector.lowerError),
                toScaleNumber(values.lowerWarningVector.lowerWarning),
                toScaleNumber(values.higherWarningVector.higherWarning),
                toScaleNumber(values.higherWarningVector.higherError)
            )
        };
    }) as unknown as EvaluationRule[];
}

function toScaleNumber(numberOrSymbol: { value: number | "Infinity" | "-Infinity" }): number {
    if (typeof numberOrSymbol.value === "string") {
        if(numberOrSymbol.value.includes("-Infinity")) {
            return -Infinity;
        }
        if(numberOrSymbol.value.includes("Infinity")) {
            return Infinity;
        }
    }
    return numberOrSymbol.value as number;
}

